import "@/assets/vendor/nucleo/css/nucleo.css";
import "@/assets/scss/dso.scss";

import globalComponents from "./globalComponents";
import globalDirectives from "./globalDirectives";
import globalMethods from "./globalMethods";
import globalVariables from "./globalVariables";
import Print from "./print";

import SidebarPlugin from "@/components/SidebarPlugin/index";
import NotificationPlugin from "@/components/NotificationPlugin/index";

export default {
  install(Vue) {
    Vue.use(globalComponents);
    Vue.use(globalDirectives);
    Vue.use(SidebarPlugin);
    Vue.use(NotificationPlugin);
    Vue.use(globalMethods);
    Vue.use(globalVariables);
    Vue.use(Print);
  }
};
